export function authToken() {
  const header = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement;
  return header?.content || "";
}
